// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_2rSq9"};